import styled from "styled-components";
import { useEffect, useState, useRef, useContext } from "react";
import { InputText } from "primereact/inputtext";
import EmailEdit from "./EmailEdit";
import { DialogWindowContext } from "../../../Contexts/DialogueWindowContext";
import { OrgTreeContext } from "../../../Contexts/OrgTreeContext";
import {
  uploadUser,
  saveOrgTree,
  addUserToOktaGroup,
  addUserToAdmin,
  removeUserFromAdmin,
} from "../../../Firebase";
import { updateOrgTreeWithNewUserRoles } from "../../../Helpers/OrgTreeFunctions";

import { Button } from "primereact/button";

import RolesEdit from "./RolesEdit";

const UserEditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  margin: 0 auto;
  min-width: 300px;
  align-items: flex-start;
  p {
    font-size: 12px;
    margin-top: 5px;
  }
  .p-inputtext {
    margin: 2px 0 5px 0;
  }
  .p-inputtext,
  .p-treeselect,
  .p-inputwrapper {
    width: 270px;
  }
  .p-inputswitch {
    margin: 5px 0;
  }
`;

export default function UserEdit(props: Props) {
  const { teamMember } = props;
  const [user, setUser] = useState<UserData>();
  const DialogWindow = useContext(DialogWindowContext);
  const orgTree = useContext(OrgTreeContext);

  useEffect(() => {
    teamMember && setUser(teamMember);
  }, [teamMember]);

  const saveDetails = () => {
    if (!user || !orgTree) return;
    user && uploadUser(user);
    //updateTeamTree
    const newOrgTree = updateOrgTreeWithNewUserRoles(orgTree, user);
    saveOrgTree(newOrgTree);

    if (user.PCRoles) {
      //check for added admin roles
      user.PCRoles.forEach((role) => {
        if (
          role.role == "admin" && 
          !teamMember.PCRoles.some(
            (oldRole) =>
              oldRole.role == "admin" && oldRole.teamId === role.teamId
          )
        ) {
          user.firebaseUid && addUserToAdmin(user, role.teamId);
          console.log("admin added");
        }
      });
      //check for deleted admin roles
      teamMember.PCRoles.forEach((role) => {
        console.log(role)
        if (
          role.role == "admin" &&
          !user.PCRoles.some(
            (newRole) =>
              newRole.role == "admin" && newRole.teamId === role.teamId
          )
        ) {
          user.firebaseUid && removeUserFromAdmin(user);
          console.log("admin removed");
        }
      });
    }

    DialogWindow.setDialogProps({
      ...DialogWindow,
      showEditWindow: false,
    });
  };

  const inputChange = (e: any) => {
    if (e.target.id.includes("firstName") && user) {
      setUser({ ...user, firstName: e.target.value });
    }
    if (e.target.id.includes("lastName") && user) {
      setUser({ ...user, lastName: e.target.value });
    }
  };

  return (
    <>
      {user && (
        <UserEditWrapper>
          <p>First Name</p>
          <InputText
            id={`firstName-id-${teamMember.userId}`}
            value={user.firstName}
            onChange={(e) => inputChange(e)}
          />
          <p>Last Name</p>
          <InputText
            id={`lastName-id-${teamMember.userId}`}
            value={user.lastName}
            onChange={(e) => inputChange(e)}
          />
          <p>Okta Email(s)</p>
          <EmailEdit user={user} setUser={setUser} />

          {props.selectedTeam && <RolesEdit user={user} setUser={setUser} selectedTeam={props.selectedTeam} />}

          <Button
            label="Save"
            style={{ marginTop: "10px", border: "none" }}
            severity="success"
            icon="pi pi-check"
            onClick={saveDetails}
          />
        </UserEditWrapper>
      )}
    </>
  );
}

interface Props {
  teamMember: UserData;
  selectedTeam?: OrgTreeItem;
}
